var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53027 12.5C2.53027 6.98 7.01027 2.5 12.5303 2.5C18.0503 2.5 22.5303 6.98 22.5303 12.5C22.5303 18.02 18.0503 22.5 12.5303 22.5C7.01027 22.5 2.53027 18.02 2.53027 12.5ZM13.5303 13.5H17.5303V11.5H13.5303V7.5H11.5303V11.5H7.53027V13.5H11.5303V17.5H13.5303V13.5Z",
    fill: "#0D6EFD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/AddCircle.92914137.svg";
export { ForwardRef as ReactComponent };